import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=334686bc&scoped=true"
import script from "./ReminderModal.vue?vue&type=script&lang=js"
export * from "./ReminderModal.vue?vue&type=script&lang=js"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=334686bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334686bc",
  null
  
)

export default component.exports